<template>
  <v-container class="pa-1">
    <v-layout>
      <v-flex xs12 mx-auto>
        <!-- search the data based on date -->
        <v-card flat class="ma-2">
          <v-card-text class="pa-0">
            <v-flex xs12>
              <v-layout row wrap>
                <v-flex xs12 sm4 class="pt-2 text-xs-left grey-lighten-4">
                  <span v-for="(chip, index) in chips" :key="index">
                    <v-chip small @click="loadSlaScoreBasedOnPeriod(chip)" :class="enableChip === chip ? 'primary white--text' : ''">
                      {{chip}}
                    </v-chip>
                  </span>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-layout row wrap class="ml-2" v-if="enableChip === 'Specific Month'">
                    <v-flex xs10 sm6 class="pa-0">
                      <v-dialog ref="dlgSLAScoreMon"
                      persistent v-model="dlgSLAScoreMon"
                      max-width="290px"
                      :return-value.sync="selectedYearMonth"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                          slot="activator" label="Month &amp; Year"
                          :rules="[rules.required]"
                          v-model="lslaScoreInput.sla_monthAndYear" append-icon="mdi-calendar-today"
                          readonly clearable hide-details
                          v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker type="month"
                        v-model="lslaScoreInput.sla_monthAndYear" scrollable
                        first-day-of-week="1"
                        >
                          <v-spacer></v-spacer>
                          <v-btn text @click="dlgSLAScoreMon = false">Cancel</v-btn>
                          <v-btn text color="accent" @click="$refs.dlgSLAScoreMon.save(lslaScoreInput.sla_monthAndYear)">OK</v-btn>
                        </v-date-picker>
                      </v-dialog>
                    </v-flex>
                    <v-flex xs2 sm2 class="text-xs-left">
                      <v-btn small fab class="accent" @click.native="getSpecificMonthDetails()">Go</v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex class="text-xs-left">
                  <v-btn color="accent" @click="downloadAsPdf()">Save as Pdf</v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout >
      <v-flex xs12 mx-auto id="pdf_report">
        <v-card >
          <v-card-title class="pa-2 title">
            <v-flex xs12>
              <v-layout row wrap>
                <v-flex xs6>
                  <div class="text-s-left pt-2 headtext"><h2>{{config.COMM_NAME}}</h2></div>
                  <div class="text-xs-left pt-2">SLA Score Card [ {{this.fromMonth}}-{{this.fromYear}} ]</div>
                </v-flex>
                <v-flex xs6>
                  <div class="text-xs-right">
                    <img height="45" src="../../static/img/logo/smartility_admin.png"/>
                  </div>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12>
              <v-divider style="border-top:1px solid brown"></v-divider>
            </v-flex>
          </v-card-title>
          <v-card-text class="pa-2" >
            <v-data-table
            :headers="SLAScoreCardHeader"
            :items="slaScoreList"
            :item-class="itemRowBackground"
            class="elevation-2"
            disable-initial-sort
            hide-actions
            >
            <template slot="items" slot-scope="props">
                <tr @click="updateSLAScoreCard(props.item)" style="background-color:#FBFFDF" class="myBorder pa-2" >
                  <td style="text-align:left" class="myBorder" >{{ props.item.comp_cat }}</td>
                  <td style="text-align:left" class="myBorder breakline pa-2" >{{ props.item.kpi_area }}</td>
                  <td style="text-align:left" class="myBorder breakline pa-2" >{{ props.item.kpi_measure }}</td>
                  <td style="background-color:#FEE1C3;font-size:20px;text-align:center" class="myBorder" >{{ props.item.self_score }}</td>
                  <td style="background-color:#FEE1C3;font-size:20px;text-align:center" class="myBorder" >{{ props.item.ops_score }}</td>
                  <td style="background-color:#CDFEC3;font-size:20px;text-align:center" class="myBorder" >{{ props.item.mc_score }} </td>
                  <td style="text-align:left" class="myBorder breakline pa-2" >{{ props.item.remarks }} </td>
                </tr>
              </template>
            </v-data-table>
            <v-layout>
              <v-flex xs3 pa-3>
                <span class="primary--text header pl-0" style="font-size: 17px;text-align:right">Total Score</span>
                <v-text-field
                  box
                  hide-details
                  type="Number"
                  maxlength="2"
                  style="font-size: 16px"
                  >
                </v-text-field>
              </v-flex>
              <v-flex xs3 pa-3>
                <span class="primary--text header pl-0" style="font-size: 17px;text-align:right">Percentage Score</span>
                <v-text-field
                  box
                  hide-details
                  type="Number"
                  maxlength="2"
                  style="font-size: 16px"
                  >
                </v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- Submit SLA Score -->
    <v-dialog v-model="showSubmitScore" max-width="900px"  full-height>
      <v-container grid-list-md class="pa-0" fluid full-height>
        <v-layout>
          <v-flex xs12>
            <v-form ref="lEditSLAForm" @submit.prevent="saveChanges(lAction)">
              <v-card scrollable>
                <v-card-title style="font-size: 17px" class="primary white--text py-0">
                  SLA Score - {{lSLAScore.comp_cat}}
                  <v-spacer></v-spacer>
                  <v-btn icon small @click.stop="showSubmitScore = false"><v-icon>close</v-icon></v-btn>
                </v-card-title>
                <v-card-text>
                  <v-layout >
                    <v-flex xs12>
                      <span class="primary--text subheader pl-0">KPI Area</span>
                      <v-textarea
                      v-model="lSLAScore.kpi_area"
                      box
                      rows="8"
                      readonly
                      multi-line
                      ></v-textarea>
                    </v-flex>
                    <v-flex xs6 sm6>
                      <span class="primary--text subheader pl-0">KPI Measure</span>
                      <v-textarea
                      v-model="lSLAScore.kpi_measure"
                      background-color="amber lighten-4"
                      readonly
                      multi-line
                      rows="8"
                      dense
                      box
                      ></v-textarea>
                    </v-flex>
                  </v-layout>
                <v-layout >
                  <v-flex xs12 sm10 class="d-flex pa-2">
                      <span class="primary--text subheader pl-0">FM Score</span>
                      <v-text-field
                      v-model="lSLAScore.self_score"
                      box
                      hide-details
                      type="Number"
                      maxlength="1"
                      style="font-size: 16px"
                      :disabled = "config.IS_FM !== true"
                      >
                    </v-text-field>
                      <span class="primary--text subheader pl-0">OPS Score</span>
                      <v-text-field
                      v-model="lSLAScore.ops_score"
                      box
                      hide-details
                      type="Number"
                      maxlength="1"
                      style="font-size: 16px"
                      ></v-text-field>
                      <span class="primary--text subheader pl-0">MC Score</span>
                      <v-text-field
                      v-model="lSLAScore.mc_score"
                      box
                      hide-details
                      type="Number"
                      maxlength="1"
                      style="font-size: 14px"
                      :disabled = "config.ROLE_NAME !== 'President' && config.ROLE_NAME !== 'Joint Secretary' && config.ROLE_NAME !== 'Secretary' && config.ROLE_NAME !== 'Treasurer' && config.ROLE_NAME !== 'Vice President'"
                      ></v-text-field>
                    </v-flex>
                </v-layout>
                  <v-layout>
                      <v-flex xs 12>
                        <span class="primary--text subheader pl-0">Remarks</span>
                        <v-textarea
                        v-model="lSLAScore.remarks"
                        multi-line
                        dense
                        box
                        maxlength="50"
                        hide-details
                        ></v-textarea>
                      </v-flex>
                  </v-layout>
                </v-card-text>
                <v-card-actions class="pt-0">
                  <v-layout row wrap>
                    <v-spacer></v-spacer>
                    <v-btn class="ma-2" color="red lighten-1" text-color="white" @click.stop="showSubmitScore = false">Cancel</v-btn>
                    <v-btn class="ma-2" color="green lighten-1" text-color="white" type="submit" :disabled="beingSaved">Save</v-btn>
                  </v-layout>
                </v-card-actions>
              </v-card>
            </v-form>
          </v-flex>
        </v-layout>
      </v-container>
    </v-dialog>
    <!-- snack bar for reporting -->
    <v-snackbar :color="sbarCol" v-model="sbar" :timeout="3000" multi-line>
      <span class="mx-auto">{{ sbarMsg }}</span>
    </v-snackbar>
  </v-container>
</template>


<script>
import config from '@/config/app-cfg'
import handy from '@/utils/handy'
// import { VueEditor } from 'vue2-editor'
var html2pdf = require('html2pdf.js')
import VDownloadAs from './VDownloadAs.vue'

export default {
  components:
  {
    'v-download-as': VDownloadAs
  },
  data () {
    return {
      sbar: false,
      sbarCol: 'error',
      sbarMsg: '',
      lAction: '',
      handy: handy,
      rules: handy.rules,
      config: config,
      beingSaved: false,
      chips: ['This Month', 'Last Month', 'Specific Month'],
      enableChip: '',
      selectedYearMonth: '',
      dlgSLAScoreMon: false,
      slaScoreList: [],
      lslaScoreInput: {},
      lSLAScore: [],
      lDate: handy.formatDBDate(new Date()),
      fromDate: '',
      fromMonth: '',
      fromYear: '',
      pagination: { rowsPerPage: 15 },
      SLAScoreCardHeader: [
        { text: 'Category', value: 'comp_cat', width: '180px', align: 'center', class: 'white--text pa-2 myheaderstyle' },
        { text: 'KPI Area', value: 'kpi_area', width: '500px', align: 'center', class: 'white--text pa-2 myheaderstyle' },
        { text: 'KPI Measure', value: 'kpi_measure', width: '350px', align: 'center', class: 'white--text pa-2 myheaderstyle' },
        { text: 'FM Score', value: 'self_score', width: '80px', align: 'center', class: 'white--text pa-2 myheaderstyle' },
        { text: 'OPS Score', value: 'ops_score', width: '80px', align: 'center', class: 'white--text pa-2 myheaderstyle' },
        { text: 'MC Score', value: 'mc_score', width: '80px', align: 'center', class: 'white--text pa-2 myheaderstyle' },
        { text: 'Remarks', value: 'remarks', width: '300px', align: 'center', class: 'white--text pa-2 myheaderstyle' }
      ],
      showSubmitScore: false,
      slaHeadRep: [
        { text: 'Category', value: 'comp_cat', class: 'pa-2' },
        { text: 'KPI Area', value: 'kpi_area', class: 'accent white--text pa-2 text-xs-center' },
        { text: 'KPI Measure', value: 'kpi_measure', class: 'accent white--text pa-2 text-xs-center' },
        { text: 'FM Score', value: 'self_score', class: 'accent white--text pa-0 text-xs-center' },
        { text: 'FM Score', value: 'ops_score', class: 'accent white--text pa-0 text-xs-center' },
        { text: 'MC Score', value: 'mc_score', class: 'accent white--text pa-0 text-xs-center' },
        { text: 'Remarks', value: 'remarks', class: 'accent white--text pa-2 text-xs-center' }
      ]
    }
  },
  mounted () {
    this.lAction = 'view'
    this.loadSlaScoreBasedOnPeriod('This Month')
  },
  methods: {
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    loadSlaScoreBasedOnPeriod (curChip) {
      this.enableChip = curChip
      this.fromDate = null
      if (curChip === 'This Month' || curChip === 'Last Month') {
        // find the period based on selection
        var curDate = new Date()
        var mm
        var yyyy
        if (curChip === 'Last Month') {
          mm = curDate.getMonth()
          yyyy = curDate.getFullYear()
          if (mm < 10) {
            mm = '0' + mm
          }
          if (mm === '00') {
            mm = 12
            yyyy = yyyy - 1
          }
        }
        if (curChip === 'This Month') {
          mm = curDate.getMonth() + 1
          yyyy = curDate.getFullYear()
          if (mm < 10) {
            mm = '0' + mm
          }
        }
        this.fromDate = yyyy + '-' + mm
        this.fromMonth = mm
        this.fromYear = yyyy
        this.lDate = this.fromDate
        this.loadSLAScore()
      }
    },
    getSpecificMonthDetails () {
      // Specific Month
      this.fromMonth = this.lslaScoreInput.sla_monthAndYear.substring(5, 7)
      this.fromYear = this.lslaScoreInput.sla_monthAndYear.substring(0, 4)
      this.loadSLAScore()
    },
    loadSLAScore () {
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          comm_name: config.COMM_NAME,
          fromMonth: this.fromMonth,
          fromYear: this.fromYear
        }
      }
      this.axios.get(config.API_URL + '/getSLAScoreForMonthByCommId/', qry)
      .then(response => {
        this.slaScoreList = response.data
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    itemRowBackground: function (item) {
      return item.protein > 4.2 ? 'style-1' : 'style-2'
    },
    updateSLAScoreCard (curSlaScore) {
      this.lSLAScore = Object.assign({}, curSlaScore)
      this.lAction = 'update'
      this.showSubmitScore = true
    },
    saveChanges (action) {
      if (this.$refs.lEditSLAForm.validate()) {
        if (this.lSLAScore.self_score < 0 || this.lSLAScore.self_score > 5 || this.lSLAScore.ops_score < 0 || this.lSLAScore.ops_score > 5 || this.lSLAScore.mc_score < 0 || this.lSLAScore.mc_score > 5) {
          this.msg('Please enter score between 0 to 5', 0)
        } else if (config.IS_FM === true && !this.lSLAScore.self_score) {
          this.msg('FM Score must be entered between 0 to 5', 0)
        } else if ((config.ROLE_NAME === 'President' || config.ROLE_NAME === 'Joint Secretary' || config.ROLE_NAME === 'Secretary' || config.ROLE_NAME === 'Treasurer' || config.ROLE_NAME === 'Vice President') && !this.lSLAScore.mc_score) {
          this.msg('MC Score must be entered between 0 to 5', 0)
        } else {
          this.lSLAScore.fromMonth = this.fromMonth
          this.lSLAScore.fromYear = this.fromYear
          this.axios.post(config.API_URL + '/slaScoreCard/' + action, this.lSLAScore)
          .then(response => {
            setTimeout(() => {
              this.loadSLAScore()
            }, 500)
            this.msg('Saved Successfully', 1)
            this.beingSaved = false
            this.showSubmitScore = false
          })
          .catch(err => {
            this.msg(err, 0)
            this.beingSaved = false
          })
        }
      }
    },
    downloadAsPdf () {
      // pdf options
      let opt = {
        margin: 9,
        filename: 'SLAScoreCard.pdf',
        image: { type: 'jpeg', quality: 0.95 },
        html2canvas: { scale: 2.5, dpi: 120, letterRendering: true, width: 747 },
        jsPDF: { format: 'letter' },
        pagebreak: { mode: ['avoid-all', 'legacy'] }
      }

      var canvas = document.getElementById('pdf_report')
      html2pdf().from(canvas).set(opt).toPdf().get('pdf').then(function (pdf) {
        var totalPages = pdf.internal.getNumberOfPages()

        for (var i = 1; i <= totalPages; i++) {
          pdf.setPage(i)
          pdf.setFontSize(8)
          pdf.text('Page ' + i + ' of ' + totalPages, pdf.internal.pageSize.getWidth() - 25, pdf.internal.pageSize.getHeight() - 5)
        }
      }).save()
    }
  }
}
</script>
<style>
  .myBorder {
    border: 1px solid black;
    text-align: center;
  }
  .th {
    border: 1px solid black;
    text-align: center;
  }
  .thick
  {
    font-size:14px;
  }
  .headtext
  {
    color:green
  }
  .breakline{
    white-space: pre-wrap;
    word-wrap: break-word;
  }
  .myheaderstyle {
    font-size:14px;
    border: 1px solid black;
    background-color: #665ad8;
    accent-color:white;
  }

</style>



// WEBPACK FOOTER //
// SlaScoreCard.vue?7ee4ea92